module.exports = __webpack_public_path__ + "img/scientist 2@2x.7c4a9d83.png";